import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({ data, setDisplayData, entriesperpage, Total }: any) => {
  const Paginate: any = ReactPaginate;


  // --- Pagination --- //
  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = parseInt(entriesperpage);
  const pagesVisited = pageNumber * usersPerPage;
  const pageCount = Math.ceil(data?.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  useEffect(() => {
    if(data) {
      setDisplayData(data?.slice(pagesVisited, pagesVisited + usersPerPage));
      localStorage.setItem("rowsPerPage", entriesperpage);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setDisplayData, entriesperpage, pageNumber, data]);

  return (
    <div id="tfoot-ReactPaginate">
      {data?.length === 0 ? (
        ""
      ) : (
        <div className="pageEntries">
          Total of {data?.length} {Total}
        </div>
      )}
      <div>
        {data?.length > usersPerPage && (
          <Paginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            pageCount={pageCount}
            onPageChange={changePage}
            containerClassName={"pagination-container"}
            previousLinkClassName={"previous-btn"}
            nextLinkClassName={"next-btn"}
            disabledClassName={"pagination-disabled"}
            activeClassName={"pagination-active"}
          />
        )}
      </div>
    </div>
  );
};

export default Pagination;
